import React from 'react';

import Editor from 'components/Editor';
import { Checkbox } from 'components/Misc/Form';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const Option = ({ questionId, option }) => {
	// Use exam's student store
	const slug = useExamStudentStore(state => state.exam.slug);
	const onChangeOption = useExamStudentStore(state => state.onChangeOption);

	// Handle onChange on option
	const onOption = (change) => {
		onChangeOption(questionId, option.id, change);
	};

	return (
		<div key={option.id} className="flex gap-4 items-center">
			{/* Option's selection */}
			<Checkbox
				small
				name="answer"
				value={option.answer}
				onChange={onOption}
			/>

			{/* Option's content */}
			<Editor
				readOnly
				path="exams"
				folder={slug}
				value={option?.content}
			/>
		</div>
	);
};

export default Option;